import axios from 'axios';
import {
  IInvoicePayment,
  IInvoicePaymentCreate,
  IInvoicePaymentResponse,
  IInvoicePaymentsResponse
} from '../types/invoicePayment';

const MOCK_USER_ID = "64067927a9259bbde06c6f15";

/**
 * جلب جميع دفعات فاتورة معينة
 */
export const getInvoicePayments = async (invoiceId: string): Promise<IInvoicePayment[]> => {
  try {
    const response = await axios.get<IInvoicePaymentsResponse>(
      `/api/invoice-payment-management/invoice/${invoiceId}`
    );
    return response.data.data.payments;
  } catch (error: any) {
    console.error('خطأ في جلب دفعات الفاتورة:', error);
    throw error;
  }
};

/**
 * إنشاء دفعة جديدة للفاتورة
 */
export const createInvoicePayment = async (
  payment: IInvoicePaymentCreate
): Promise<IInvoicePayment> => {
  try {
    const paymentData = {
      ...payment,
      paymentDate: payment.paymentDate || new Date().toISOString(),
      createdBy: MOCK_USER_ID
    };

    const response = await axios.post<IInvoicePaymentResponse>(
      '/api/invoice-payment-management',
      paymentData,
      {
        headers: {
          'X-User-ID': MOCK_USER_ID,
          'X-Branch-ID': localStorage.getItem('currentBranchId') || ''
        }
      }
    );
    
    return response.data.data.payment;
  } catch (error: any) {
    console.error('خطأ في إنشاء دفعة الفاتورة:', error);
    throw error;
  }
};

/**
 * حذف دفعة من الفاتورة
 */
export const deleteInvoicePayment = async (paymentId: string): Promise<void> => {
  try {
    await axios.delete(`/api/invoice-payment-management/${paymentId}`, {
      headers: {
        'X-User-ID': MOCK_USER_ID,
        'X-Branch-ID': localStorage.getItem('currentBranchId') || ''
      }
    });
  } catch (error: any) {
    console.error('خطأ في حذف دفعة الفاتورة:', error);
    throw error;
  }
};

/**
 * حساب إجمالي الدفعات لفاتورة معينة
 */
export const calculateTotalPayments = (payments: IInvoicePayment[]): number => {
  return payments.reduce((total, payment) => total + payment.amount, 0);
};

/**
 * حساب المبلغ المتبقي للفاتورة
 * يأخذ في الاعتبار: الدفعات المسجلة + المبلغ النقدي + طرق الدفع
 */
export const calculateRemainingAmount = (
  invoiceTotal: number,
  payments: IInvoicePayment[],
  cashPaidAmount: number = 0,
  paymentMethodsTotal: number = 0
): number => {
  const totalPaidFromPayments = calculateTotalPayments(payments);
  const totalPaid = totalPaidFromPayments + cashPaidAmount + paymentMethodsTotal;
  return invoiceTotal - totalPaid;
};
